
const lang = {
    en:{
        searchPlaceHolder: "What do you want to watch today? Let me help you!",
        signOut : "Sign Out",
        signIn : "Sign In",
        home : "Home",
    },
    hi:{
        searchPlaceHolder: "आज आप क्या देखना चाहते हैं? मैं आपकी मदद करूँगा!",
        signOut : "साइन आउट",
        signIn : "दाखिल करना",
        home : "होम"
    },
    bng:{
        searchPlaceHolder: "আপনি আজ কি দেখতে চান? আমাকে সাহায্য করতে দাও!",
        signOut : "সাইন আউট",
        signIn : "সাইন ইন করুন",
        home : "হোম"
    }
}

export default lang;